import React from 'react';
import { Helmet } from 'react-helmet-async';
import JsonLd from './JsonLd';
import {
  SITE_URL,
  formatPageTitle,
  formatDescription,
  buildOrganizationSchema,
  buildWebSiteSchema,
  buildWebPageSchema,
  buildSchemaGraph,
} from '../utils/seo';

export default function PageSeo({
  title,
  description,
  path,
  keywords,
  ogTitle,
  ogDescription,
}) {
  const pageTitle = formatPageTitle(title);
  const pageDescription = formatDescription(description);
  const canonicalUrl = `${SITE_URL}${path}`;
  const openGraphTitle = ogTitle ? formatPageTitle(ogTitle) : pageTitle;
  const openGraphDescription = ogDescription ? formatDescription(ogDescription) : pageDescription;

  const schema = buildSchemaGraph([
    buildOrganizationSchema(),
    buildWebSiteSchema(),
    buildWebPageSchema({
      name: pageTitle,
      description: pageDescription,
      url: canonicalUrl,
    }),
  ]);

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        {keywords ? <meta name="keywords" content={keywords} /> : null}
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:site_name" content="Merra.ai" />
        <meta property="og:title" content={openGraphTitle} />
        <meta property="og:description" content={openGraphDescription} />
        <meta property="og:url" content={canonicalUrl} />
      </Helmet>
      <JsonLd schema={schema} />
    </>
  );
}
